import { RadioGroup, Radio, LabelGroup } from '@globalmed/atlas-ui';
import { useState } from 'react';
import { TFormBuilderSingleChoiceField } from '@/types';

type TProps = {
  field: TFormBuilderSingleChoiceField;
};

/**
 * Preview component for single choice field in form builder
 * @param props - Component props
 * @param props.field - Single choice field data to preview
 * @returns Form builder single choice preview component
 */
export const FormBuilderPreviewSingleChoice = ({ field }: TProps) => {
  const [value, setValue] = useState<string>('');
  return (
    <RadioGroup
      label={field.label}
      direction="column"
      value={value}
      onChange={setValue}
      required={field.required}
    >
      {field.options.map(({ id, value }) => (
        <LabelGroup title={value} key={id}>
          <Radio value={id} radioSize="sm" aria-label={value} />
        </LabelGroup>
      ))}
    </RadioGroup>
  );
};
